<mat-accordion [ngStyle]="applyDesign()" class="dialog m-b-10">
  <mat-expansion-panel hideToggle [expanded]="panelExpanded" disabled>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="question-title-section">
          <span class="title-style">{{ title }}</span>
          <span
            *ngIf="isRequired"
            class="is-mandatory"
            [ngClass]="
              allergies().length > 0 ? 'mandatory-valid' : 'mandatory-invalid '
            "
          ></span>
        </div>
      </mat-panel-title>

      <mat-panel-description>
        <button class="add-edit-button">
          <img
            *ngIf="isAddingOrEditing === 'adding'"
            src="assets/icons/add_button.svg"
            (click)="executeFunction()"
          />
          <img
            *ngIf="isAddingOrEditing === 'editing'"
            src="assets/icons/edit_button.svg"
            (click)="executeFunction()"
          />
        </button>
      </mat-panel-description>

      <button
        mat-icon-button
        (click)="panelExpanded = !panelExpanded"
        class="no-shadow"
      >
        <img src="assets/icons/expand_icon.svg" />
      </button>
    </mat-expansion-panel-header>

    <div class="chips-rectangle-design">
      <!-- <div
        *ngFor="let allergy of filterAllergiesSelected(arrayItems)"
        style="margin: 5px 10px"
      >
        <span style="font-weight: bold"> {{ showTitle(allergy) }} </span>

        <mat-chip-set>
          <mat-chip
            *ngFor="let item of filterTypesSelected(allergy.allergyTypes)"
          >
            <div style="display: flex; align-items: center">
              <span style="margin-right: 10px" *ngIf="item.answer[0] !== ''">
                {{ item.answer[0] }}
              </span>

              <button class="add-edit-button">
                <img
                  src="assets/icons/chip_close.svg"
                  (click)="deleteAllergy(allergy, item)"
                />
              </button>
            </div>
          </mat-chip>
        </mat-chip-set>
      </div> -->
      <div class="container-novo">
        @for (allergyCat of allergies(); track $index) {
          <div class="allergy-cat">
            <span class="allergy-cat-title">
              {{ allergyCat.category }}
            </span>

            <mat-chip-set>
              <div *ngFor="let allergy of allergyCat.types">
                <mat-chip *ngIf="allergy !== ''">
                  <div style="display: flex; align-items: center">
                    <div style="margin-right: 10px">{{ allergy }}</div>

                    <button class="add-edit-button">
                      <img
                        src="assets/icons/chip_close.svg"
                        (click)="
                          remove({
                            name: allergy,
                            cat: allergyCat.category
                          })
                        "
                      />
                    </button>
                  </div>
                </mat-chip>
              </div>
            </mat-chip-set>

            <!-- <div class="allergies">
              @for (allergy of allergyCat.allergyTypes; track $index) {
                <p-chip
                  class="chip-text"
                  (onRemove)="
                    remove({ name: allergy, cat: allergyCat.allergyCategory })
                  "
                >
                  <div class="allergy-label">
                    {{ allergy }}
                  </div>
                  <i
                    class="pi pi-times-circle"
                    (click)="
                      remove({ name: allergy, cat: allergyCat.allergyCategory })
                    "
                  ></i>
                </p-chip>
              }
            </div> -->
          </div>
        }
      </div>
    </div>
  </mat-expansion-panel>
</mat-accordion>
